// extracted by mini-css-extract-plugin
module.exports = {"moderation-paginator":"moderationPaginator_moderation-paginator__1oNiO","translatable-input-header":"moderationPaginator_translatable-input-header__1C07L"};